import { Direction } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/batch/v1/batch.pb';

const DIRECTION_STORAGE_KEY = 'bulk-message-direction';

export const getDirectionStorageKey = () =>
  (sessionStorage.getItem(DIRECTION_STORAGE_KEY) as Direction) ?? Direction.DESCENDING;

export const setDirectionStorageKey = (direction: Direction) =>
  sessionStorage.setItem(DIRECTION_STORAGE_KEY, direction ?? Direction.DESCENDING);
